// // src/components/ProtectedRoute.js
// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem("token"); // ya auth context

//   return isAuthenticated ? children : <Navigate to="/login" replace />;
// };

// export default ProtectedRoute;


import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ role }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || '{}');

  if (!token) return <Navigate to="/" replace />;

  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />; // ✅ This renders the nested route
};

export default ProtectedRoute;
